import { render, staticRenderFns } from "./InspectionWarrantyRegisteredAnomaly.vue?vue&type=template&id=3b514dea&scoped=true&"
import script from "./InspectionWarrantyRegisteredAnomaly.vue?vue&type=script&lang=ts&"
export * from "./InspectionWarrantyRegisteredAnomaly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b514dea",
  null
  
)

export default component.exports